module.exports = __webpack_public_path__ + "static/media/Ornate2_Before.b7f8d280.jpg";